if (window.wp && window.wp.ajax)
{

    const { registerBlockType } = window.wp.blocks;

    const {
        RichText,
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;

    const {
        PanelBody,
        IconButton,
        TextControl
    } = window.wp.components;

    registerBlockType('custom-gutenberg/review-slide', {
        // built-in attributes
        title: 'Review Slide',
        description: 'Custom Review Slide',
        icon: 'slides',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            backgroundImage: {
                type: 'string',
                default: ''
            },

            profileImage: {
                type: 'string',
                default: ''
            },

            title: {
                type: 'string',
                default: ''
            },
            name: {
                type: 'string',
                default: ''
            },
            description: {
                type: 'string',
                default: ''
            },
            period: {
                type: 'string',
                default: ''
            },
            
        },

        // built-in functions
        edit({ attributes, setAttributes })
        {

            const {
                link,
                backgroundImage,
                profileImage,
                title,
                name,
                description,
                period,
                
            } = attributes;

            // custom functions
            function onLinkChange(link)
            {
                setAttributes({ link: link });
            };

            function onSelectImage(image)
            {
                setAttributes({ backgroundImage: image.sizes.full.url });
            }

            function onTitleChange(title)
            {
                setAttributes({ title: title });
            }

            function onNameChange(name)
            {
                setAttributes({ name });
            }

            function onProfileImageChange(profileImage)
            {
                setAttributes({ profileImage: profileImage.sizes.full.url });
            }

            function onDescriptionChange(description)
            {
                setAttributes({ description: description });
            }


            function onPeriodChange(period)
            {
                setAttributes({ period: period });
            }

            return ([
                <InspectorControls style={{ marginBottom: '40px' }}>
                    <PanelBody title={'Link'}>
                        <p><strong>Enter url: (ex: /putovanja)</strong></p>
                        <TextControl value={link} onChange={onLinkChange}></TextControl>
                    </PanelBody>
                    <PanelBody title={'Background Image Settings'}>
                        <MediaUpload
                            onSelect={onSelectImage}
                            type="image"
                            value={backgroundImage}
                            render={({ open }) => (
                                <IconButton
                                    onClick={open}
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                            )} />
                    </PanelBody>
                    <PanelBody title={'Profile Image Settings'}>
                        <MediaUpload
                            onSelect={ onProfileImageChange }
                            type="image"
                            value={ profileImage }
                            render={({ open }) => (
                                <IconButton
                                    onClick={open}
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Profile Image
                                </IconButton>
                            )} />
                    </PanelBody>
                    <PanelBody title={'Slide Content'}>
                        <p><strong>Title</strong></p>
                        <TextControl value={title} onChange={onTitleChange}></TextControl>
                        <p><strong>Name</strong></p>
                        <TextControl value={name} onChange={onNameChange}></TextControl>
                        <p><strong>Description</strong></p>
                        <TextControl value={description} onChange={onDescriptionChange}></TextControl>
                        <p><strong>Period</strong></p>
                        <TextControl value={period} onChange={onPeriodChange}></TextControl>                      
                    </PanelBody>
                </InspectorControls>
                ,
                <div class="keen-slider__slide">
                    <div class="cover-image" style={{ height: 350, backgroundImage: `url(${backgroundImage})` }}>
                        <div class="container">
                            <a class="content">
                                <RichText
                                    key="editable"
                                    tagName="div"
                                    className="description"
                                    placeholder="DESCRIPTION"
                                    value={description}
                                    onChange={onDescriptionChange} />
                                <RichText
                                    key="editable"
                                    tagName="h2"
                                    className="title"
                                    placeholder="Title"
                                    value={title}
                                    onChange={onTitleChange} />
                            
                            </a>
                        </div>
                    </div>
                </div>
            ]
            );
        },

        save({ attributes })
        {
            const {
                link,
                backgroundImage,
                title,
                description,
                period,
                name,
                profileImage,
              
            } = attributes;

            return (
                // <div class="cover-image home-review-slide lozad keen-slider__slide" data-background-image={backgroundImage}>
                //     <div class="container slider-content">
                //         <div class="row justify-content-center">
                //             <div class="col-lg-10">
                //                 <div class="subtitle">{description}</div>
                //                 <h2 class="title">{title}</h2>
                //                 <h3 class="period">{period}</h3>
                //                 <a href={link} class="cta">
                //                     <div class="btn btn-primary rounded-pill px-lg-4 view-more-btn">
                //                         {viewMore}
                //                     </div>
                //                 </a>
                //             </div>
                //         </div>
                //     </div>
                // </div>
                <div>
                <div class="h-100 w-100">
                    <div class="keen-slider__slide px-1">
                        <a href={ link } target="_blank" class="h-100 w-100 text-decoration-none">
                            <div class="row gx-0">
                                <div class="col-12 col-lg-5 pe-lg-5 h-100 slider-card">
                                    <div class="square-div">
                                        <div class="lozad bg-dark h-100 img-slider__card h-100" data-background-image= { backgroundImage } style="min-height: 250px;">

                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-7">
                                    <div class="card-body py-3 py-md-4 py-lg-2 py-xl-2 py-xxl-4 h-100 d-flex flex-column ps-3 pe-3 pe-lg-0 text-dark">
                                        <div class="row">
                                            <div class="col-lg h-100">
                                                <h5 class="card-title pb-1 pb-md-3 h-100">{ title }</h5>
                                            </div>                               
                                        </div>                                        
                                            <div class="row pb-2 pb-md-3">
                                                <div class="col-auto">
                                                    <div>
                                                       <img class="circle-div" src= { profileImage } />
                                                    </div>
                                                </div>
                                                <div class="col-auto d-flex flex-column justify-content-center gx-1">
                                                    <div>
                                                        { name }
                                                    </div>
                                                    <div>
                                                        <p class="mb-0 mb-md-2 text-muted pt-1">{ period }</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <p class="mb-0">{ description }</p>
                                            <span class="d-flex align-items-center text-primary small fw-semibold pt-2 see-span"> See this villa  <i class="las la-long-arrow-alt-right la-lg text-primary ps-1">  </i> </span>
                                                        
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    </div>
                </div>
            );
        },
    });
}